import React from 'react';
import { HeaderGroup } from 'react-table';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import './table-head.scss';

interface TableHeadProps<T extends object = {}> {
	headerGroups: HeaderGroup<T>[];
	sortable?: boolean;
}

const HEADER = 'Header';
const TableHead = <T extends object = {}>(props: TableHeadProps<T>) => {
	const { headerGroups, sortable } = props;

	return (
		<div className="bringg-table-head" data-test-id="table-head">
			{headerGroups.map(headerGroup => (
				<div {...headerGroup.getHeaderGroupProps()} className="head-row">
					{headerGroup.headers.map(column => {
						return (
							<div {...column.getHeaderProps()} className="header-cell" data-test-id="table-header-cell">
								<div className="table-header-text">
									<span>{column.render(HEADER)}</span>
									{sortable && (
										<span>
											{column.isSorted ? (
												column.isSortedDesc ? (
													<BringgIcon
														iconName={BringgFontIcons.SortDesc}
														data-test-id="sort-desc-icon"
													/>
												) : (
													<BringgIcon
														iconName={BringgFontIcons.SortAsc}
														data-test-id="sort-asc-icon"
													/>
												)
											) : null}
										</span>
									)}
								</div>
							</div>
						);
					})}
				</div>
			))}
		</div>
	);
};

export default TableHead;
